import styled from 'styled-components';

import { ColorTypes, TintTypes } from '@folx-types/theme';

import bulletIcon from '@assets/vectors/bullet-icon.svg';

import theme from '@theme/WsTheme';

import { ITextVariants } from './BasicText';

export interface IWYSIWYGContentProps {
	border?: boolean;
	color?: ColorTypes;
	linkColor?: ColorTypes;
	linkFontWeight?: 'normal' | 'bold';
	linkTint?: TintTypes;
	linkUnderline?: boolean;
	tint?: TintTypes;
	bulletType?: string;
	textVariant?: ITextVariants;
}

const WYSIWYGContent = styled.div<IWYSIWYGContentProps>`
	p,
	span,
	li {
		color: ${({ color = 'black', tint }) =>
			tint ? theme.tints[tint](theme.colors[color]) : theme.colors[color]};
		font-weight: ${({ theme: components, textVariant = 'body' }) =>
			components.basicText[textVariant].fontWeight};
	}

	a,
	a span,
	li a,
	span a {
		text-decoration: ${({ linkUnderline = false }) => (linkUnderline ? 'underline' : 'none')};
		color: ${({ linkColor = 'black', linkTint }) =>
			linkTint ? theme.tints[linkTint](theme.colors[linkColor]) : theme.colors[linkColor]};
		font-weight: ${({ linkFontWeight = 'bold' }) => linkFontWeight};
	}

	a,
	a span,
	li,
	li a,
	p,
	span a {
		font-family: ${({ theme: components }) => components.fontFamily};
		font-size: ${({ theme: components, textVariant = 'body' }) =>
			components.basicText[textVariant].fontSize.mobile};
		line-height: ${({ theme: components, textVariant = 'body' }) =>
			components.basicText[textVariant].lineHeight};

		@media ${theme.responsive.breakpoints.tablet} {
			font-size: ${({ theme: components, textVariant = 'body' }) =>
				components.basicText[textVariant].fontSize.tablet};
		}
	}

	i,
	em {
		font-style: italic;
	}

	b,
	strong {
		font-family: 'Chalet-NewYorkSixty';
	}

	> p + p {
		margin-top: 1.2rem;
	}

	ol,
	ul {
		list-style: ${({ bulletType = `url(${bulletIcon})` }) => bulletType};
		margin-left: 2.4rem;

		li {
			font-size: ${({ theme: components, textVariant = 'body' }) =>
				components.basicText[textVariant].fontSize.mobile};
			line-height: ${({ theme: components, textVariant = 'body' }) =>
				components.basicText[textVariant].lineHeight};
			padding-left: 1.6rem;

			@media ${theme.responsive.breakpoints.tablet} {
				font-size: ${({ theme: components, textVariant = 'body' }) =>
					components.basicText[textVariant].fontSize.tablet};
			}
		}

		> li + li {
			margin-top: 1.2rem;
		}
	}

	h4 {
		font-size: ${theme.fontSizes.header.md};
		line-height: ${theme.lineHeights.header.md};
	}

	h4 + h4 {
		margin-top: ${theme.spacing.lgxl};
	}
`;

export default WYSIWYGContent;
